"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["title", "subtitle", "headerButtons", "showCloseButton", "onClose"];
var DialogHeader = function DialogHeader(props) {
  var title = props.title,
    subtitle = props.subtitle,
    headerButtons = props.headerButtons,
    showCloseButton = props.showCloseButton,
    onClose = props.onClose,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, remainingProps, {
    className: "modal-header"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header-text"
  }, subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header-subtitle"
  }, subtitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header-title"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header-buttons"
  }, headerButtons && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, headerButtons, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header-buttons-spacer"
  })), showCloseButton && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-icon-only btn-muted modal-header-close close",
    onClick: onClose,
    "data-testid": "close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-remove",
    "aria-hidden": "true"
  }))));
};
DialogHeader.defaultProps = {
  showCloseButton: true,
  onClose: function onClose() {}
};
DialogHeader.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  showCloseButton: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  headerButtons: _propTypes["default"].node
};
var _default = DialogHeader;
exports["default"] = _default;